function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Upload, InputNumber, Flex, Tag, Space, Radio, Image, Alert, notification } from 'antd';
import { PlusCircleFill, EnvelopeAtFill, CashStack } from "react-bootstrap-icons";
import axios from 'axios';
import Common from "../includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var ChangePlan = function ChangePlan(_ref) {
  var handler = _ref.handler,
    businessAccount = _ref.businessAccount;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    pmList = _useState6[0],
    setPmList = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    pg = _useState8[0],
    setPg = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    unitPrice = _useState0[0],
    setUnitPrice = _useState0[1];
  var _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    totalAmount = _useState10[0],
    setTotalAmount = _useState10[1];
  var _useState11 = useState(1),
    _useState12 = _slicedToArray(_useState11, 2),
    periode = _useState12[0],
    setPeriode = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    plans = _useState14[0],
    setPlans = _useState14[1];
  var _useState15 = useState(1),
    _useState16 = _slicedToArray(_useState15, 2),
    receptionMode = _useState16[0],
    setReceptionMode = _useState16[1];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    formData.append('subscription_plan_id', values.subscription_plan_id);
    formData.append('payment_gateway_id', values.payment_gateway_id);
    formData.append('businessAccount_id', businessAccount.id);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'changesubscriptionplan', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.code == 0) {
        console.log(JSON.stringify(response.data));
        window.location.href = response.data.payment_url;
      } else {
        setErrorMessage(response.data.error_message);
      }
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };
  var handlePlanChange = function handlePlanChange(v) {
    if (plans.filter(function (p) {
      return p.value == v.target.value;
    })[0].price - businessAccount.subscription_plan.monthly_price > 0) setTotalAmount(plans.filter(function (p) {
      return p.value == v.target.value;
    })[0].price - businessAccount.subscription_plan.monthly_price);else {
      setTotalAmount(0);
    }
  };
  useEffect(function () {
    axios.all([axios.get(Common.baseApiUrl + 'getpgs'), axios.get(Common.baseApiUrl + 'getsubscriptionplans/' + businessAccount.country_id)]).then(function (response) {
      if (response[0].data.status == 200) {
        setPmList([]);
        response[0].data.pgs.forEach(function (pg) {
          setPmList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: pg.id,
              label: /*#__PURE__*/_jsxs(Flex, {
                gap: "small",
                justify: "center",
                align: "center",
                vertical: true,
                children: [/*#__PURE__*/_jsx(Image, {
                  preview: false,
                  width: "210px",
                  src: "drawables/" + pg.logo
                }), /*#__PURE__*/_jsx("b", {
                  children: pg.label
                })]
              })
            }]);
          });
        });
        if (response[0].data.pgs.length > 0) {
          form.setFieldsValue({
            payment_gateway_id: response[0].data.pgs[0].id
          });
          setPg(response[0].data.pgs.filter(function (g) {
            return g.pdcode == 'CC';
          })[0]);
        }
        if (response[1].data.status == 200) {
          response[1].data.plans.forEach(function (e) {
            if (e.id != businessAccount.subscription_plan_id) {
              setPlans(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  price: e.monthly_price,
                  value: e.id,
                  label: /*#__PURE__*/_jsxs("div", {
                    style: {
                      width: "100%",
                      marginBottom: "5px",
                      borderRadius: "7px",
                      padding: "8px",
                      border: "1px solid #E1DCC5"
                    },
                    gap: "small",
                    justify: "center",
                    align: "center",
                    vertical: true,
                    children: [/*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      children: [/*#__PURE__*/_jsx("div", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: e.label
                        })
                      }), /*#__PURE__*/_jsxs(Tag, {
                        color: "#40714A",
                        children: [e.monthly_price.toLocaleString("Fr"), " GNF / Mois"]
                      })]
                    }), /*#__PURE__*/_jsx("p", {
                      children: e.description
                    })]
                  })
                }]);
              });
            }
          });
          if (response[1].data.plans.filter(function (p) {
            return p.id != businessAccount.subscription_plan_id;
          }).length > 0) {
            setTotalAmount(response[1].data.plans.filter(function (p) {
              return p.id != businessAccount.subscription_plan_id;
            })[0].monthly_price - businessAccount.subscription_plan.monthly_price);
            form.setFieldsValue({
              subscription_plan_id: response[1].data.plans.filter(function (p) {
                return p.id != businessAccount.subscription_plan_id;
              })[0].id
            });
          }
        }
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue, verifiez votre connexion internet " + error.toString()
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "middle",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          sm: 12,
          xs: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            size: "large",
            label: "Choisir la formule souhait\xE9e",
            name: "subscription_plan_id",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Radio.Group, {
              style: {
                width: "100%"
              },
              options: plans,
              onChange: handlePlanChange
            })
          })
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "payment_gateway_id",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          disabled: totalAmount <= 0,
          options: pmList
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(CashStack, {}),
          loading: isFormLoading,
          type: "primary",
          size: "large",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: totalAmount > 0 ? "Choisir et payer ".concat(totalAmount.toLocaleString('Fr')) : "Choisir"
          })
        })
      })]
    })
  });
};
export default ChangePlan;